import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { NotificationModel } from '../models/notification.model';
import { RecaptchaModel } from '../models/recaptcha.model';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private baseRoute: string;
  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.formbuilderAPIUrlRoot;
  }

  loadAll<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getallrecaptchakeys`);
  }

  pubLoadAll<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getrecaptchakeys`);
  }

  upsertRecaptcha(data: RecaptchaModel) {
    return this.httpClient.post(`${this.baseRoute}/saverecaptchakey`, data);
  }

  loadRecaptchaById(id: number) {
    return this.httpClient.get(`${this.baseRoute}/getrecaptchakeybyid/${id}`);
  }

  pubLoadRecaptchaById(id: number) {
    return this.httpClient.get(`${this.baseRoute}/getrecaptchakey/${id}`);
  }

  deleteRecaptcha(id: number, userId: number) {
    return this.httpClient.delete(
      `${this.baseRoute}/deleterecaptchakey/${id}/${userId}`
    );
  }

  validateRecaptcha(id: number, token: string) {
    const data = { Id: id, Token: token };
    return this.httpClient.post(
      `${this.baseRoute}/validaterecaptchatokenbykey`,
      data
    );
  }

  validatehcaptcha(id: number, token: string) {
    const data = { Id: id, Token: token };
    return this.httpClient.post(
      `${this.baseRoute}/validatehcaptchatokenbykey`,
      data
    );
  }
}
